var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzureDataLakeDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1511b",
    d: "M11.178 11.178H0V0h11.178z",
    transform: "translate(20.266 20.267)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80cc28",
    d: "M188.178 11.178H177V0h11.177v11.178z",
    transform: "translate(-144.445 20.267)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00adef",
    d: "M11.178 188.178H0V177h11.178z",
    transform: "translate(20.266 -144.444)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc09",
    d: "M188.178 188.178H177V177h11.177v11.178z",
    transform: "translate(-144.445 -144.444)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureDataLakeDefault);
export default __webpack_public_path__ + "static/media/azure_data_lake-default.38d6a8e477abe956abe86e34c6a5c40b.svg";
export { ForwardRef as ReactComponent };